<template>
  <div class="modal fade" id="CreateET" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="col">
            <h3>Erroneous Transfer</h3>
          </div>
        </div>
        <div class="container-fluid">
          <div class="modal-body">

            <div class="row justify-content-center" v-if="!registrations || !registrations.length">
              <div class="col-12">
                <label for="tenanciesNumber" class="d-block">
                  Meter Point Number
                  <b-form-input v-model="mpxn" type="text" placeholder="Enter Meter Point Number"/>
                </label>
              </div>

              <div class="col-auto">
                <button class="btn" @click="getTenancies">Search</button>
              </div>

              <div class="col-auto">
                <button class="btn"
                data-dismiss="modal">Cancel</button>
              </div>
            </div>

            <div class="row justify-content-center" v-else-if="!selectedRegistration">
              <div class="col-12">
                <label for="RegistrationPeriod" class="d-block">
                  Registration Period
                  <b-form-select class="d-block" v-model="selectedRegistration" @input="getCustomer">
                    <option v-for="opt of registrationOptions" :key="opt.id" :value="opt">
                      <span class="p-3">
                        {{ opt.from }} - {{ opt.to }}
                      </span>
                    </option>
                  </b-form-select>
                </label>
              </div>

              <div class="col-auto">
                <button class="btn" data-dismiss="modal">Cancel</button>
              </div>
            </div>

            <div v-else>
              <div class="row">
                <div class="col">
                  <FormCreateElectricity v-if="selectedRegistration.serviceType == 'Electricity'"
                    :tenancy="selectedRegistration.tenancy" :customer="customer" :meterpoint="meterpoint"
                    :registration="selectedRegistration" @submit="submitElectricity" />
                  <FormCreateGas v-if="customer && selectedRegistration && selectedRegistration.serviceType == 'Gas'"
                    :customer="customer" :tenancy="selectedRegistration.tenancy" :meterpoint="meterpoint"
                    :registration="selectedRegistration" @submit="submitGas" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import FormCreateElectricity from "@/components/modals/ETs/CreateElectricity.vue";
import FormCreateGas from "@/components/modals/ETs/CreateGas.vue";
import snotifyHttpError from "@/mixins/snotifyHttpResponses";

export default {
  name: "EtCreate",

  mixins: [snotifyHttpError],

  components: { FormCreateElectricity, FormCreateGas },

  props: [],

  data() {
    return {
      mpxn: undefined,
      registrations: undefined,
      selectedRegistration: undefined,
      customer: undefined,
      meterpoint: undefined,
    };
  },

  computed: {
    flowbot() {
      return {
        gas: `https://${Vue.config.honeycomb.flowbot.gas.domain}`,
        Gas: `https://${Vue.config.honeycomb.flowbot.gas.domain}`,
        elec: `https://${Vue.config.honeycomb.flowbot.electricity.domain}`,
        Electricity: `https://${
          Vue.config.honeycomb.flowbot.electricity.domain
        }`,
      };
    },

    contractbot() {
      return `https://${Vue.config.honeycomb.contractbot.domain}`;
    },

    registrationOptions() {
      if (!this.registrations) return;
      return this.registrations.map((r) => ({
        sharedId: r.SharedId,
        from: moment(r.EffectiveFrom).format("ll"),
        to: (r.EffectiveTo && moment(r.EffectiveTo).format("ll")) || "Ongoing",
        customerId: r.CustomerId,
        serviceType: r.ServiceType,
        tenancy: r.tenancy,
        gainedFromId: r.GainedFromId,
        supplierId: r.SupplierId,
        elecSupplierId: Vue.config.honeycomb.supplierId
      }));
    },
  },

  mounted() {
    $("#CreateET").on("hidden.bs.modal", () => {
      this.reset();
    });
  },

  methods: {
    async getTenancies() {
      const url = `${this.contractbot}/api/v1/tenancies/byServiceIdentifier/${
        this.mpxn
      }`;
      const { data } = await this.$http.get(url, { withCredentials: true });
      this.tenancies = data;

      if (!this.tenancies.length) {
        this.$snotify.warning("No results found");
        return;
      }

      await this.getRegistrations(this.tenancies);
    },

    // prettier-ignore
    async getRegistrations(tenancies) {
      this.registrations = [];

      // Group tenancies by unique registration key to avoid duplicate API calls
      const byRegistration = new Map();
      for (const t of tenancies) {
        const sharedId = t[`${t.ServiceType}TenancyDetails`].RegistrationSharedId;
        const key = `${t.ServiceType}:${sharedId}`; // prevent cross-service collisions
        if (!byRegistration.has(key)) {
          byRegistration.set(key, t);
        }
      }

      // Fetch each unique registration (and meterpoint) only once
      const res = await Promise.all(
        // This conversion to an array is required because Promise.all() expects an array of promises
        Array.from(byRegistration.values()).map(async (t) => {
          const details = t[`${t.ServiceType}TenancyDetails`];
          const regUrl = `${this.flowbot[t.ServiceType]}/api/v1/registrations/${details.RegistrationSharedId}`;
          const { data } = await this.$http.get(regUrl, { withCredentials: true });

          // Attach context from representative tenancy
          data.CustomerId = t.CustomerId;
          data.ServiceType = t.ServiceType;
          data.tenancy = t;

          // Fetch meterpoint once per unique registration
          this.meterpoint = await this.getMeterpoint(
            t.ServiceType,
            details.MeterPointSharedId
          );

          return data;
        })
      );

      this.registrations = res.filter((r) => ['Live', 'Lost'].includes(r.RegistrationStatus));

      if (!this.registrations.length) this.$snotify.warning('No results found');
    },

    async getMeterpoint(st, sharedId) {
      const url = `${this.flowbot[st]}/api/v1/meterpoints/${sharedId}`;
      const { data } = await this.$http.get(url, { withCredentials: true });
      return data;
    },

    async getCustomer() {
      const { data } = await this.$http.get(
        `${this.contractbot}/api/v1/Customers/${
          this.selectedRegistration.customerId
        }`,
        { withCredentials: true }
      );
      this.customer = data;
    },

    reset() {
      this.mpxn = undefined;
      this.registrations = undefined;
      this.selectedRegistration = undefined;
      this.customer = undefined;
      this.meterpoint = undefined;
    },

    submitElectricity(form) {
      $("#CreateET").modal("hide");

      this.$snotify.async("Creating ET...", () =>
        new Promise((resolve, reject) => {
          this.$http
            .post(`${this.flowbot.elec}/api/v1/erroneoustransfers`, form, {
              withCredentials: true,
            })
            .then(() =>
              resolve({
                body: "ET Created",
                config: {
                  closeOnClick: true,
                  timeout: 2000,
                },
              })
            )
            .catch((err) => {
              reject(this.snotifyHttpError(err));
            });
        }).finally(() => {
          this.$emit("refresh");
        })
      );
    },

    submitGas(form) {
      $("#CreateET").modal("hide");
      this.$snotify.async("Creating ET...", () =>
        new Promise((resolve, reject) => {
          this.$http
            .post(`${this.flowbot.gas}/api/v1/erroneoustransfers`, form, {
              withCredentials: true,
            })
            .then(() =>
              resolve({
                body: "ET Created",
                config: {
                  closeOnClick: true,
                  timeout: 2000,
                },
              })
            )
            .catch((err) => {
              reject(this.snotifyHttpError(err));
            });
        }).finally(() => {
          this.$emit("refresh");
        })
      );
    },
  },
};
</script>
